import { useServiceClient } from 'common';
import { IGetTextData } from 'modules/shared/queries';
import { useQuery } from 'react-query';
import { getUserProfilePayloadDefault } from '../defaults';
import { useConfigScopeSelectors } from '../scopes';
import { CorePageEndPoints, CorePageQueryKey } from './query-enums';

export function useUserSettingsQuery() {
    const { getData } = useServiceClient();
    const currentUserDetails = useConfigScopeSelectors().selectCurrentUserDetails();

    const getUserSettingss = () => getData(`${CorePageEndPoints.GET_USER_SETTINGS}_${currentUserDetails.userName.replace(/\\/g, '_')}`).then((res) => res.json())
        .catch((e) => {
            console.log('User details is empty');
            console.log('Error', e);
            return {
                TextData: JSON.stringify(getUserProfilePayloadDefault(currentUserDetails.userName))
            };
        });
    return useQuery<IGetTextData>(CorePageQueryKey.GET_USER_SETTINGS, getUserSettingss);
}
